const config = {
    // 默认请求方式为 get
    method: 'get',
    // 请求超时时间
    timeout: 60 * 1000,
    // 请求头
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    },
    baseURL: '',
    // 跨域时是否携带凭证
    withCredentials: false,
    Authorization: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjIyMzMyNzY0OTcsInRva2VuVHlwZSI6Imp3dCIsInVzZXJJZCI6MX0.7tyTXTyNtx_dn9O-I1f-89DdHnmZg6lx_4Z2x_sxTV8',
};

const env = process.env.NODE_ENV;
let qRCodeId = '86'

if (env === 'development') {
    config.baseURL = 'https://edu-test1.anoah.com';
    qRCodeId = '86'
} else if (env === 'test') {
    qRCodeId = '86'
    if(window.location.pathname.includes('mirror')){
        config.baseURL = 'https://edu-m1.anoah.com';
    }else{
        config.baseURL = 'https://edu-test1.anoah.com';
    }
} else if (env === 'production') {
    qRCodeId = '98'
    config.baseURL = 'https://youxueketang.anoah.com';
}

export {
    config,
    qRCodeId
} 

